/**
 * CORE-BI (constitution l.46, l.127) — on the operator's own recommendation,
 * say which shop preference shaped it and in which direction.
 *
 * The sentences are authored by the server (smart-assign, from
 * `_shared/cultureInfluence.ts`) for exactly the preferences that changed the
 * outcome; this component only renders them. It renders nothing when the
 * server reported no influence — an always-present attribution says nothing.
 */
import { SlidersHorizontal } from 'lucide-react';

export interface CultureInfluenceItem {
  key: string;
  value: number | boolean;
  direction: 'allowed' | 'held_back';
  text: string;
}

export function isCultureInfluenceList(raw: unknown): raw is CultureInfluenceItem[] {
  return (
    Array.isArray(raw) &&
    raw.every(
      (i) =>
        i !== null &&
        typeof i === 'object' &&
        typeof (i as CultureInfluenceItem).key === 'string' &&
        typeof (i as CultureInfluenceItem).text === 'string',
    )
  );
}

export function CultureInfluenceNote({
  items,
  testId = 'culture-influence',
}: {
  items: unknown;
  testId?: string;
}) {
  if (!isCultureInfluenceList(items) || items.length === 0) return null;
  return (
    <div className="space-y-0.5" data-testid={testId}>
      {items.map((item) => (
        <p
          key={`${item.key}:${item.direction}`}
          className="flex items-start gap-1 text-xs text-muted-foreground"
          data-culture-key={item.key}
          data-culture-direction={item.direction}
        >
          <SlidersHorizontal className="mt-0.5 h-3 w-3 shrink-0" aria-hidden="true" />
          <span>{item.text}</span>
        </p>
      ))}
    </div>
  );
}
